<template>
  <div class="login">
    <div id="content" class="content">
        <div class="pure-form pure-form-aligned splash-head" autocomplete="off">
            <fieldset>
                <div class="pure-control-group">
                    <label for="account">Benutzer</label>
                    <input id="account" v-model="account" type="text" placeholder="Username">
                    <!--<span class="pure-form-message-inline">This is a required field.</span>-->
                </div>

                <div class="pure-control-group">
                    <label for="password">Passwort</label>
                    <input id="password" v-model="password" type="password" placeholder="Password" autocomplete="new-password">
                </div>
                <div id="buttonBar" class="pure-control-group">
                    <button class="pure-button" v-on:click="login">Anmelden</button>
                </div>
            </fieldset >
        </div>
        <div id="error" v-if="hasError()">
            <p>{{ error }}</p>
        </div>
    </div>
  </div>
</template>

<script>
import { doLogin } from '@/utils/auth.js'

export default {
  name: "login",
  data: function () {
      return {
        account: '',
        password: '', 
        error: ''
      }
  },
  mounted: function() {

      document.getElementById("account").focus()
  },
  methods: {

      login: function(event) {

        doLogin(this, this.account, this.password)
      },
      hasError: function() {
        
        return this.error != null && this.error != ''
      },
      setError(error) {

          this.error = error
      }

  }
};
</script>


<style scoped>

#content  {
    margin-right: auto; 
    margin-left: auto;
    width: 400px;
    position: relative;
    top: 50px;
}

#error {
    border: 1px solid red;
    color: red;
}

#buttonBar {
    text-align: right;
    padding-right: 20px;
}

</style>